import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ExploreStyle from "../../assets/stylesheets/common/FarmExplore.module.css";

/**
 * FarmExplore
 * props:
 * - tabs?: { key: string; label: string; icon?: React.ReactNode; isNew?: boolean }[]
 * - value?: string (controlled)
 * - defaultValue?: string
 * - onChange?: (key: string) => void
 * - renderContent?: (key: string) => React.ReactNode
 */

export function FarmExploreNav({ isScrolled = false }) {
  const location = useLocation();
  const path = location.pathname;

  return (
    <nav aria-label="Explore categories" className={`${ExploreStyle["explore-nav"]} ${isScrolled ? ExploreStyle["hidden"] : ''}`}>
      <Link
        to="/"
        className={`${ExploreStyle["nav-item"]} ${(!path.startsWith('/stay') && !path.startsWith('/experience') && !path.startsWith('/store')) ? ExploreStyle["nav-active"] : ''}`}
      >
        <span>Farm</span>
      </Link>
      <Link
        to="/experience"
        className={`${ExploreStyle["nav-item"]} ${path.startsWith('/experience') ? ExploreStyle["nav-active"] : ''}`}
      >
        <span>Experience</span>
      </Link>
      <Link
        to="/stay"
        className={`${ExploreStyle["nav-item"]} ${path.startsWith('/stay') ? ExploreStyle["nav-active"] : ''}`}
      >
        <span>Stay</span>
      </Link>
      
      <Link
        to="/store"
        className={`${ExploreStyle["nav-item"]} ${path.startsWith('/store') ? ExploreStyle["nav-active"] : ''}`}
      >
        <span>Store</span>
      </Link>
    </nav>
  );
}